var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('div',{staticClass:"main"},[_c('router-view')],1),_c('pro-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }